/**
 * Sprint V102.i (23.09.2026) — Zentrale Pro-Solo-Trial-Copy fuer alle
 * Upsell-Teaser im Free-Plan. Ein Ort, damit spaetere Preis-/Text-Aenderungen
 * (z.B. wenn Trial mal auf 3€ oder 0€ wechselt) an einer Stelle passieren.
 *
 * Verwendung:
 *   import { PRO_TRIAL_COPY } from "@/lib/proTrialCopy";
 *   <span>{PRO_TRIAL_COPY.priceLine}</span>
 *   <button>{PRO_TRIAL_COPY.ctaLabel}</button>
 */

export const PRO_TRIAL_COPY = {
  /** Kompakter Button-Text — passt in schmale Karten */
  ctaLabel: "7 Tage für 1 € testen",
  /** Etwas expressiver, mit Pfeil */
  ctaLabelArrow: "7 Tage für 1 € testen →",
  /** Untertext direkt unter CTA-Button */
  priceLine: "Danach 39 €/Monat · Jederzeit kündbar.",
  /** Fuer Inline-Hinweise, wenn kein Button dabei ist */
  inlineHint: "7 Tage für 1 € testen — danach 39 €/Monat.",
  /** Fallback-Label wenn User bereits Trial hatte (Doppel-Trial-Block) */
  ctaLabelDirect: "Pro Solo starten",
  priceLineDirect: "39 €/Monat · Jederzeit kündbar.",
};

/**
 * Waehlt automatisch die richtige Copy je nach User-Status.
 * - Free-User ohne bisherigen Trial: bekommt Trial-CTA
 * - Free-User mit `trial_started_at` in der Vergangenheit: direkter Standard-Kauf-CTA
 * - Alles andere (Pro, Trial aktiv, Pionier): Aufrufer sollte den Teaser eh nicht rendern
 */
export function pickProSoloCopy(user) {
  const hadTrial = !!user?.trial_started_at;
  if (hadTrial) {
    return {
      ctaLabel: PRO_TRIAL_COPY.ctaLabelDirect,
      ctaLabelArrow: `${PRO_TRIAL_COPY.ctaLabelDirect} →`,
      priceLine: PRO_TRIAL_COPY.priceLineDirect,
      inlineHint: null,
      isTrialEligible: false,
    };
  }
  return {
    ctaLabel: PRO_TRIAL_COPY.ctaLabel,
    ctaLabelArrow: PRO_TRIAL_COPY.ctaLabelArrow,
    priceLine: PRO_TRIAL_COPY.priceLine,
    inlineHint: PRO_TRIAL_COPY.inlineHint,
    isTrialEligible: true,
  };
}
